/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeesAddComponent
 * Purpose		: This component allows to create new Employees record and save changes.
 * Dependency	: EmployeesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit,
	HostBinding, trigger, transition, animate,
	style, state } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { EmployeesData, EmployeesService } from './Employees.service';


@Component({
	selector: 'my-Employees-add',
	template: require('./EmployeesAdd.component.html'),
	providers: [EmployeesService
		
		],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class EmployeesAddComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }

	objEmployees: EmployeesData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	
	EmployeesList: EmployeesData[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
	private toastr: ToastsManager,
    private EmployeesService: EmployeesService

	) {
		this.objEmployees = new EmployeesData();
	}

	ngOnInit() {
		this.objEmployees = new EmployeesData();
		this.getLookups();
	}

	addEmployees() {
		this.EmployeesService.addEmployeesData(this.objEmployees)
			.subscribe(record => this.router.navigate(['/Employees']),
			error =>  this.errorMessage = 'There was an error while adding record. Error: ' + <any>error,
			() => { 
				this.toastr.success('Employees record added successfully...', 'Add Employees');
				console.log('Employees record added successfully...'); 
			}
		);
	}

	gotoEmployees() {
		// let Id = this.objEmployees ? this.objEmployees.EmployeeID : null;
		this.router.navigate(['/Employees']);
	}

	// Get Lookup List for Employees
    getEmployees() {
		this.EmployeesService.getAll().subscribe(records => this.EmployeesList=records);
    }

	getLookups() {

        this.getEmployees();
	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Employees/EmployeesAdd.component.ts